// extracted by mini-css-extract-plugin
module.exports = {"viewDownloadsModalWrapper":"py","header":"pz","headline":"pA","closeIcon":"pB","modalCloseIcon":"pC"};